module.exports = __webpack_public_path__ + "01_short_yellow.d40d9fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_short_yellow.png
// module id = L2NI
// module chunks = 0